import {
    Row,
    Col,
    Icon
} from 'antd';
import {i18n} from '../public/i18n';
import isEmpty from 'lodash/isEmpty';

class InfoGroup4Formal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showGroup: true
        }
    }
    render() {
        const {
            title,
            items,
            colLeft = 6,
            colRight = 15,
            hide,
        } = this.props;
        const {
            showGroup
        } = this.state;
        const colArr = [];
        items && items.forEach((obj, index) => {
            let showValue;
            if (obj.isOpenHrm) {
                showValue = obj.showName != '' ? <a href={`javaScript:openhrm(${obj.value})`} onClick={event => window.pointerXY(event)}>{obj.showName}</a> : <div>&nbsp;</div>;
            } else {
                showValue = obj.value ? <div dangerouslySetInnerHTML={{__html:obj.value}}/> : <div>&nbsp;</div>;
            }
            colArr.push(
                <Col span={24/2}>
                    <Row>
                    <Col className="wea-info-group-content-cell-label" span={colLeft}>
                        {obj.label ? obj.label : <div>&nbsp;</div>}:
                    </Col>
                    <Col className="wea-info-group-content-cell-value" span={colRight} >
                        { showValue }
                    </Col>
                  </Row>
                </Col>
            );
        })
        return (
            <div className="wea-info-group" style={hide?{display:'none'}:null}>
                <Row className="wea-info-group-title">
                    <Col span={20}>
                        <div className='wea-info-group-title-info'>{title}</div>
                    </Col>
                    <Col span={4} style={{textAlign:"right",paddingRight:10,fontSize:12,lineHeight:'32px'}}>
                        <i style={{cursor: 'pointer'}} className={showGroup ? 'icon-coms-up' : 'icon-coms-down'} onClick={()=>this.setState({showGroup:!showGroup})}/>
                    </Col>
                </Row>
                <Row className="wea-info-group-content" style={showGroup ? null : {display:'none'}} >
                    {colArr}
                </Row>
            </div>
        )
    }

}

class InfoGroup4Formal1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showGroup: true
        }
    }
    render() {
        const {
            title,
            items,
            colLeft = 6,
            colRight = 18
        } = this.props;
        const {
            showGroup
        } = this.state;
        const colArr = [];
        items && items.forEach((obj, index) => {
            let showValue;
            if (obj.isOpenHrm) {
                showValue = obj.showName != '' ? <a href={`javaScript:openhrm(${obj.value})`} onClick={event => window.pointerXY(event)}>{obj.showName}</a> : <div>&nbsp;</div>;
            } else {
                showValue = obj.value ? <div dangerouslySetInnerHTML={{__html:obj.value}}/> : <div>&nbsp;</div>;
            }
            colArr.push(
                <Row>
                    {obj.label && 
                        <Col className="wea-info-group-content-cell-label" span={colLeft}>
                            {obj.label ? obj.label : <div>&nbsp;</div>}:
                        </Col>
                    }
                    <Col className="wea-info-group-content-cell-value" span={obj.label ?colRight:24} >
                        {showValue}
                    </Col>
                </Row>
            );
        })

        if(isEmpty(colArr) || colArr.length==0){
            colArr.push(<li style={{textAlign:'center',listStyleType:'none'}}>
            <div style={{width:'100%',fontSize:'30px'}}><i className='icon-coms-NoData'></i></div>
            <div style={{color:'#B2B2B2'}}>{i18n.message.dataNone()}</div>
            </li>)
        }
        return (
            <div className="wea-info-group">
                <Row className="wea-info-group-title">
                    <Col span={20}>
                        <div className='wea-info-group-title-info'>{title}</div>
                    </Col>
                    <Col span={4} style={{textAlign:"right",paddingRight:10,fontSize:12,lineHeight:'32px'}}>
                        <i style={{cursor: 'pointer'}} className={showGroup ? 'icon-coms-up' : 'icon-coms-down'} onClick={()=>this.setState({showGroup:!showGroup})}/>
                    </Col>
                </Row>
                <Row className="wea-info-group-content" style={showGroup ? null : {display:'none'}} >
                    {colArr}
                </Row>
            </div>
        )
    }
}

class InfoGroup4Formal2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showGroup: true
        }
    }
    render() {
        const {
            title,
            items
        } = this.props;
        const {
            showGroup
        } = this.state;
        const colArr = [];
        items && items.forEach((obj, index) => {
            colArr.push(
                <Row className="wea-info-group-row">
                    <Col className="wea-info-group-content-cell-label" span={6}>
                        {obj.label}
                    </Col>
                    <Col className="wea-info-group-content-cell-value" span={18}>
                        <Col  span={14} >
                            {obj.value}
                        </Col>
                        <Col span={10} dangerouslySetInnerHTML={{__html:obj.link}}>
                        </Col>
                    </Col>
                </Row>
            );
        })
        return (
            <div  className="wea-info-group">
                <Row className="wea-info-group-title">
                    <Col span={20}>
                        <div className='wea-info-group-title-info'>{title}</div>
                    </Col>
                    <Col span={4} style={{textAlign:"right",paddingRight:10,fontSize:12,lineHeight:'32px'}}>
                        <i style={{cursor: 'pointer'}} className={showGroup ? 'icon-coms-up' : 'icon-coms-down'} onClick={()=>this.setState({showGroup:!showGroup})}/>
                    </Col>
                </Row>
                <Row className="wea-info-group-content" style={showGroup ? null : {display:'none'}} >
                    {colArr}
                </Row>
            </div>
        )
    }
}

class InfoGroup4Formal3 extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            title,
            items,
            colLeft = 6,
            colRight = 18
        } = this.props;
        const colArr = [];
        items && items.forEach((item, index) => {
            let children = [];
            colArr.push(<Col span={12}>{children}</Col>);
            item.map((obj, index) => {
                let showValue;
                if (obj.isOpenHrm) {
                    showValue = obj.showName != '' ? <a href={`javaScript:openhrm(${obj.value})`} onClick={event => window.pointerXY(event)}>{obj.showName}</a> : <div>&nbsp;</div>;
                } else {
                    showValue = obj.value ? <div dangerouslySetInnerHTML={{__html:obj.value}}/> : <div>&nbsp;</div>;
                }
                children.push(
                    <Row>
                        <Col className="wea-info-group-new-content-cell-label" span={colLeft}>
                            {obj.label ? obj.label : <div>&nbsp;</div>}:
                        </Col>
                        <Col className="wea-info-group-new-content-cell-value" span={colRight} >
                            {showValue}
                        </Col>
                    </Row>
                );
            })
        })
        return (
            <div className="wea-info-group-new">
                <Row className="wea-info-group-new-title">
                    <Col span={24}>
                        <div className='wea-info-group-new-title-info'>{title}</div>
                    </Col>
                </Row>
                <Row className="wea-info-group-new-content" gutter={64}>
                    {colArr}
                </Row>
            </div>
        )
    }
}

export {
    InfoGroup4Formal,
    InfoGroup4Formal1,
    InfoGroup4Formal2,
    InfoGroup4Formal3
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/coms/infoGroup4Formal.js